/**
 * --------------------------------------------------------------------------
 * NJ : Navbar.js
 * --------------------------------------------------------------------------
 */

import { Data, EventHandler, SelectorEngine } from 'nj-utils';
import AbstractComponent from 'nj-components/AbstractComponent';
import { EVENT as COLLAPSE_EVENT } from 'nj-components/Collapse';
import { coreConfig } from 'nj-components/core.config';

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME     = `${coreConfig.KEY_PREFIX}-navbar`;
const DATA_KEY = `${coreConfig.KEY_PREFIX}.navbar`;

const CLASS_NAME = {
  shownCollapse : `${NAME}--shown-collapse`
};

const SELECTOR = {
  navbar        : `.${NAME}`
};

class Navbar extends AbstractComponent {
  constructor(element) {
    super(Navbar, element);

    this.element = element;

    if (this.element) {
      Data.setData(element, DATA_KEY, this);
    }
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static handleCollapseShow(event) {
    SelectorEngine.closest(event.target, SELECTOR.navbar)
      .classList.add(CLASS_NAME.shownCollapse);
  }

  static handleCollapseHide(event) {
    SelectorEngine.closest(event.target, SELECTOR.navbar)
      .classList.remove(CLASS_NAME.shownCollapse);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static init(options) {
    return super.init(this, options, SELECTOR.navbar);
  }

  static selector = SELECTOR.navbar;
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */
EventHandler
  .on(document, COLLAPSE_EVENT.show, SELECTOR.navbar, (event) => {
    Navbar.handleCollapseShow(event);
  });

EventHandler
  .on(document, COLLAPSE_EVENT.hidden, SELECTOR.navbar, (event) => {
    Navbar.handleCollapseHide(event);
  });

export default Navbar;
